// Define action constants
const ADD = "ADD";
const CHANGE = "CHANGE";
const UPDATE = "UPDATE";
const CART = "CART";
const CART_HTML = "CART_HTML";
const CART_DRAWER_HTML = "CART_DRAWER_HTML";

// Define function to interact with the server
const performServerAction = async function(data, action = ADD, from) {
  let url = "/cart/add.js";
  let method = action.includes("CART") ? "GET" : "POST";

  if (action === CHANGE) url = "/cart/change.js";
  if (action === UPDATE) url = "/cart/update.js";
  if (action === CART) url = "/cart.js";
  if (action === CART_HTML) url = "/cart";
  if (action === CART_DRAWER_HTML) url = window.location.pathname+'?section_id=cart-drawer';


  if (action == ADD && from) {
    var headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    }
    var body = data;
  } else {
    var headers = {
      "Content-Type": action.includes("HTML") ? "text/html" : "application/json",
      "X-Requested-With": "xmlhttprequest",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: 0
    }
    var body = data && JSON.stringify(data);
  }

  try {
    // Perform fetch request
    const response = await fetch(url, {
      method: method,
      credentials: "same-origin",
      headers: headers,
      body: body
    });

    // Parse response
    const responseData = await (action.includes("HTML") ? response.text() : response.json());

    // Handle response
    if (responseData.status) {
      throw new Error(responseData.description);
    }

    return responseData;
  } catch (error) {
    console.error(error);
  }
};
// Define function to add items to the cart
const addItemFormToCart = async function(fromData, redirect) {
  try {
    const response = await performServerAction(fromData);
    if (!response) return;
    if (redirect) {
      window.location.href = '/cart'
    } else {
      if (window.location.pathname == '/cart') {
        updateCart();
      } else {
        updateCartDrawer();
      }
    }
  } catch (error) {
    console.error(error);
  }
};
// Define function to add items to the cart
const addItemToCart = async function(itemId, redirect) {
  const item = {
    id: itemId,
    quantity: 1
  };
  try {
    const response = await performServerAction(item);
    if (!response) return;
    if (redirect) {
      window.location.href = '/cart'
    } else {
      if (window.location.pathname == '/cart') {
        updateCart();
      } else {
        updateCartDrawer();
      }
    }
  } catch (error) {
    console.error(error);
  }
};
// Define function to add multiple items to cart
const addItemsToCart = async function(items, redirect) {
  try {
    const response = await performServerAction({ items: items });
    if (!response) return;
    if (redirect) {
      window.location.href = '/cart'
    } else {
      if (window.location.pathname == '/cart') {
        updateCart();
      } else {
        updateCartDrawer();
      }
    }
  } catch (error) {
    console.error(error);
  }
};
// Define function to update cart items
const updateCartItems = async function(updates) {
  try {
    const response = await performServerAction({ updates: updates }, UPDATE);
    if (!response) return;
    if (window.location.pathname == '/cart') {
      updateCart();
    } else {
      updateCartDrawer();
    }
  } catch (error) {
    console.error(error);
  }
};
const updateCartSingleItems = async function(id, quantity) {
  try {
    const dataToSend = {
      id: id,
      quantity: quantity
    };
    const response = await performServerAction(dataToSend, CHANGE);
    if (!response) { return; }
    if (window.location.pathname == '/cart') {
      updateCart();
    } else {
      updateCartDrawer();
    }
  } catch (error) {
    console.error(error);
  }
}
// Define function to get cart state
const getCartState = async function() {
  try {
    const cartData = await performServerAction(null, CART);
    if (!cartData) return;
    return cartData;
  } catch (error) {
    console.error(error);
  }
};
// Define function to update cart item count
const updateCartItemCount = function(amount) {
  const cartItemCountElement = document.querySelector(".header_cart_summary");
  if (cartItemCountElement) {
    cartItemCountElement.innerHTML = amount;
  }
};
// Define function to update cart item count
const updateCartDItemCount = function(amount) {
  const cartItemCountElement = document.querySelector("[data-cart-amount]");
  if (cartItemCountElement) {
    cartItemCountElement.innerHTML = amount;
  }
};
// Define function to update cart
const updateCart = async function() {
  const cartContentElement = document.querySelector("[data-cart-content]");
  
  await performServerAction(null, CART_HTML).then(cartHtml => {
    if (!cartHtml) return;
    
    const parser = new window.DOMParser();
    const cartHtmlDoc = parser.parseFromString(cartHtml, "text/html");
    const newCartContent = cartHtmlDoc.querySelector("[data-cart-content]");
    const cartQuantityElement = cartHtmlDoc.querySelector(".header_cart_summary");

    if (cartContentElement) {
      cartContentElement.innerHTML = newCartContent.innerHTML;
    }
    
    if (cartQuantityElement) {
      updateCartItemCount(cartQuantityElement.innerHTML);
    }
  }).catch(error => console.error(error));
};

const updateCartDrawer = async function() {
  const cartContentElement = document.querySelector("[data-cart-content]");
  var carData = await getCartState();
  await performServerAction(null, CART_DRAWER_HTML).then(cartHtml => {
    if (!cartHtml) return;

    const parser = new window.DOMParser();
    const cartHtmlDoc = parser.parseFromString(cartHtml, "text/html");
    const newCartContent = cartHtmlDoc.querySelector("[data-cart-content]");
    // const cartQuantityElement = cartHtmlDoc.querySelector("[data-cart-amount]");

    if (cartContentElement) {
      cartContentElement.innerHTML = newCartContent.innerHTML;
    }

    // if (cartQuantityElement) {
      updateCartDItemCount(Shopify.formatMoney(carData.total_price));
    // }
    if ($(".down_popup").length && $(".down_popup").hasClass("active")) {
      $(".down_popup").removeClass("active"); 
    }
  }).catch(error => console.error(error))
  .finally(() => {
    setTimeout(function() {
      openCartDrawer();
    }, 500)
  });
};

function openCartDrawer() {
  if (!$('.cart-drawer').hasClass('open')) {
    $('.cart-drawer').addClass('open');
  }
  $('[data-add-to-cart-button]').removeClass('loader');
  $('[data-add-to-cart-button]').removeAttr('disabled');
  $('.add_to_basket .add_to_cart').removeClass('loader');
  $('.add_to_basket .add_to_cart').removeClass('disabled');
}

function closeCartDrawer() {
  $('.cart-drawer').removeClass('open');
}

$(document).ready(function () {
  var breakpoint = window.matchMedia("(min-width:1280px)");
  var mySwiper;
  var breakpointChecker = function () {
    if (breakpoint.matches === true) {
      if (mySwiper !== undefined) mySwiper.destroy(true, true);
      return;
    } else if (breakpoint.matches === false) {
      return enableSwiper();
    }
  };
  var enableSwiper = function () {
    $('.usp_wpr .main_usp_row_list').each(function(i, v) {
      mySwiper = new Swiper(v, {
        slidesPerView: 1,
        draggable: true,
        // autoplay: {
        //   delay: 3000,
        // },
        breakpoints: {
          767: {
            slidesPerView: 3,
          },
          480: {
            slidesPerView: 2,
          }
        },
      });
    });
  };
  breakpoint.addListener(breakpointChecker);
  breakpointChecker();
  
  $(".masthead__toggle").click(function () {
    $(".main_menu, body").toggleClass("active_menu"); 
    $(".has-panel").removeClass("is-open");
  });
  
  function headermenu() {
    if ($(window).width() < 1281) {
      $('body').on('click', '.acnav__label.has-sub', function(e) {
        e.preventDefault();
        var label = $(this);
        var parent = label.parent(".has-panel"); 
        if (parent.hasClass("is-open")) {
          parent.removeClass("is-open");
        } else {
          parent.addClass("is-open");
        }
      });
  
      $('body').on('click', '.main_label', function(e) {
        e.preventDefault();
        var label = $(this);
        var parent = label.parent(".has-panel");
        if (parent.hasClass("is-open")) {
          // parent.removeClass('is-open');
          $(".has-panel").removeClass("is-open");
        } else {
          parent.addClass("is-open");
        }
      });
    }
  }
  headermenu();
  // $(window).on('resize orientationchange', function () {
  //     headermenu();
  // });
  
  $(".menu-overlay").click(function () {
    $(".main_menu, body").removeClass("active_menu");
    $(".has-panel").removeClass("is-open");
  });
  
  $(".back_arrow").click(function () {
    $(this).closest(".hd_nav").find(".has-panel").removeClass("is-open");
  });
  
  $(".mob_back_inner").click(function () {
    $(this)
      .closest(".mega_menu_inner")
      .find(".has-panel")
      .removeClass("is-open");
  });

  // footer accordion
  $(".ft_menu h6").click(function () {
    $(this).parent(".ft_menu").toggleClass("active").find("ul").slideToggle();
    $(this)
      .parent(".ft_menu")
      .prevAll(".ft_menu")
      .removeClass("active")
      .find("ul")
      .slideUp();
    $(this)
      .parent(".ft_menu")
      .nextAll(".ft_menu")
      .removeClass("active")
      .find("ul")
      .slideUp();
  });

  // responsive search btn
  $(".search_btn").click(function () {
    $(".search_input").slideToggle();
  });

  //product tab , product details page tabs
  $("body").on("click", ".featured_top_tab .tab_link", function (e) {
    e.preventDefault();
    var tab_id = $(this).attr("data-tab");
    var $this = $(this);
    $(".featured_top_tab .tab_link").removeClass("active");
    $(".main_product_view,.pro_view_inner").removeClass("active");
    $(this).addClass("active");
    $("#" + tab_id).addClass("active");  
  });

  
  // FEATURED CATEGORY tab
  $("body").on("click", "ul.tabs li", function () {
    var tab_id = $(this).attr("data-tab");
    $(this).closest(".browse_ev_wpr").find("ul.tabs li").removeClass("active");
    $(this)
      .closest(".browse_ev_wpr")
      .find(".cv_item_view")
      .removeClass("active");
    $(this).addClass("active");
    $(this).closest(".browse_ev_wpr").find("#" + tab_id).addClass("active");
  });

  //faq sec
  $(".filter_top_wrap .filter-box:first-child .filter_heading,.article_faq .filter-box:first-child .filter_heading")
    .addClass("active_ft_menu")
    .siblings(".filter_content")
    .slideDown();
  $("body").on("click", ".filter_heading", function () {
    $(".filter_heading").removeClass("active_ft_menu");
    $(".filter-box .filter_content").slideUp();
    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown();
      $(this).addClass("active_ft_menu");
    }
  });

  // all car type mobile slider
  (function () {
    "use strict";
    var breakpoint = window.matchMedia("(min-width:1281px)");
    var mySwiper;
    var breakpointChecker = function () {
      if (breakpoint.matches === true) {
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };
    var enableSwiper = function () {
      mySwiper = new Swiper(".all_car_type .all_car_type_wpr", {
        slidesPerView: 2,
        loop: false,
        breakpoints: {
          1180: {
            slidesPerView: 5,
          },
          640: {
            slidesPerView: 3,
          },
        },
      });
    };
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  })();

  // product slider
    function proSlider() {
      var swiper = new Swiper(".featured_section .main_product .product_slider_wpr", {
        slidesPerView: 1,
        // spaceBetween: 15,
        draggable: true,
        freeMode: true,
        mousewheelControl: true,
        behavior: "smooth",
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        breakpoints: {
          1025: {
            slidesPerView: 2,
          },
          991: {
            slidesPerView: 1,
          },
          640: {
            slidesPerView: 1,
          },
          480: {
            slidesPerView: 2,
          },
        },
      });
    }
    proSlider();

  // all car models section
  (function () {
    "use strict";
    var breakpoint = window.matchMedia("(min-width:1024px)");
    var mySwiper;
    var breakpointChecker = function () {
      if (breakpoint.matches === true) {
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };
    var enableSwiper = function () {
      mySwiper = new Swiper(".ctgrys_sec .ctgrys__list", {
        slidesPerView: 1,
        loop: false,
        breakpoints: {
          767: {
            slidesPerView: 3,
          },
          480: {
            slidesPerView: 2,
          },
        },
      });
    };
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  })();
  
  // best for charging slider 
  (function () {
    "use strict";
    var breakpoint = window.matchMedia("(min-width:1025px)");
    var mySwiper;
    var breakpointChecker = function () {
      if (breakpoint.matches === true) {
        if (mySwiper !== undefined) mySwiper.destroy(true, true);
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };
    var enableSwiper = function () {
      mySwiper = new Swiper(".best_for_charging .product_slider_wpr", {
        slidesPerView: 1,
        draggable: true,
        breakpoints: {
          480: {
            slidesPerView: 2,
          }
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
       paginationClickable: true,
      });
    };
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  })();
  
  //Cart related JS Start
  $('body').on('click', '[data-cart-open]', function(e) {
    e.preventDefault();
    openCartDrawer();
  });

  $('body').on('click', function(e) {
    if (!$('.drawer-wpr').is(e.target) && $('.drawer-wpr').has(e.target).length === 0 && !$('[data-cart-open]').is(e.target) && $('[data-cart-open]').has(e.target).length === 0 && $('.main-drawer').hasClass('open')) {
      closeCartDrawer();
    }
  });

  $('body').on('click', '[data-cart-close]', function(e) {
    e.preventDefault();
    closeCartDrawer();
  });
  
  document.addEventListener("click", (e) => {
    if (e.target.closest(".pro_content")) {
      var target = e.target.closest(".add_to_basket .add_to_cart");
      if (target) { // Ensure the target exists
        target.classList.add('loader'); // Add 'loader' class
        target.classList.add('disabled');
        var itemId = target.dataset.product;
        addItemToCart(itemId, false);
      }
    }
  });
  $('body').on('click', '.qty_wrap .qty_btn', function() {
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if ($(this).hasClass('qty-plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if (ip == 0) {
      return false;
    }
    input.val(ip);
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
      },
      success: async function() {
        if (window.location.pathname == '/cart') {
          await updateCart();
        } else {
          await updateCartDrawer();
        }
      }
    });
  });
  $('body').on('change', '[data-cart-content] .cart_qty select', function() {
    var ip = parseInt($(this).val());
    var id = parseInt($(this).attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
      },
      success: async function() {
        if (window.location.pathname == '/cart') {
          await updateCart();
        } else {
          await updateCartDrawer();
        }
      }
    });
  });
  $('body').on("click", "[data-cart-content] .cart_remove", function(e) {
    e.preventDefault();
    var id = $(this).data('id');
    $.ajax({
      type: "POST",
      dataType: "json",
      url: "/cart/update.js",
      data: 'updates['+id+']=0',
      error: function(x,y,z) {
        console.log(x);
      }
    }).done(async function(){
      if (window.location.pathname == '/cart') {
        await updateCart();
      } else {
        await updateCartDrawer();
      }
    });
  });
  // collection & product slider
  function pro_collection() {
    var swiper = new Swiper(".pro_view_slider .main_pro_des", {
      slidesPerView: 1.30,
      draggable: true,
      loop: false,
      spaceBetween: 10,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      navigation: {
        nextEl: ".sb_arrow_next",
        prevEl: ".sb_arrow_prev",
      },
       breakpoints: {
        1170: {
          slidesPerView: 3,
        },
        641: {
          slidesPerView: 2,
        },
        480:{
          slidesPerView: 2.60,
        }
      },
    });
  }
  pro_collection();

  function video_collection() {
    var swiper = new Swiper(".pro_view_slider .main_pro_video", {
      slidesPerView: 1.29,
      draggable: true,
      loop: false,
      spaceBetween: 10,
      // slidesOffsetAfter: 16,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      navigation: {
        nextEl: ".sb_arrow_next",
        prevEl: ".sb_arrow_prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 1.67,
        }
      },
    });
  }
  video_collection();

   function logo_collection() {
    var swiper = new Swiper(".pro_view_slider .main_pro_logo", {
      slidesPerView:'auto',
      draggable: true,
      loop: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
    });
  }
  logo_collection();
  
  // product tabs and blog tab
  document.querySelectorAll('.all_pro_tabs li').forEach(function(tab) {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      var tab_id = this.getAttribute('data-tab');
      var tabs = document.querySelectorAll('.all_pro_tabs li');
      var contents = document.querySelectorAll('.pro_view_inner');
      
      tabs.forEach(function(tab) {
        tab.classList.remove('active');
      });
      contents.forEach(function(content) {
        content.classList.remove('active');
      });
      this.classList.add('active');
      var target = document.getElementById(tab_id);
      if (target) {
        window.scrollTo({
          top: target.offsetTop,
          behavior: 'smooth'
        });
      }
    });
  });
  
  /* collection product search */
  $('.mg_right_menu').each(function() {
    var $group_search = $(this);
    $group_search.find('.collection_select').on('change', function() {
      var selectedValue = $(this).val();
      var $updatedOption = $group_search.find('.product_select');
      $updatedOption.empty();
      var title = $updatedOption.attr('data-title');
      var $disabledSelectedOption = $('<option>', {
        value: '',
        text: title,
        disabled: true,
        selected: true
      });
      $updatedOption.append($disabledSelectedOption);
      $.getJSON('/collections/' + selectedValue + '/products.json', function(data) {
        let sortedProducts = data.products;
        if (Array.isArray(data.products)) {
          sortedProducts = data.products.sort((a, b) => a.title.localeCompare(b.title));
        } else {
          console.error("Data is not an array. Please check the API response.");
        }
        $.each(sortedProducts, function(index, product) {
          var $option = $('<option>', {
            value: product.handle,
            text: product.title.replace(' EV Charging Cable','').replace(' Charging Cable','')
          });
          $updatedOption.append($option);
        });
      }).fail(function() {
        console.error('Error fetching products');
      });
      $updatedOption.removeAttr("disabled");
    });
    $group_search.find('.search_product').on('click', function(event) {
      event.preventDefault();
      var collection_value = $group_search.find('.collection_select').val();
      var product_value = $group_search.find('.product_select').val();
      if (!collection_value) {
        alert('Please select a make.');
      } else if (!product_value) {
        window.location.href = '/collections/' + collection_value;
        // alert('Please select a product.');
      } else {
        window.location.href = '/products/' + product_value;
      }
    });
  });

  $('body').on('keyup', '[name="plate-number"]:not(.blog-reg)', function(e) {
    var form = $(this).parents('.registration_form');
    if ($(this).val() != '') {
      form.find('.registration_button').removeAttr('disabled');
    } else {
      form.find('.registration_button').attr('disabled', 'disabled');
    }
  });
  
  $('body').on('click', '.registration_button', function(e) {
    e.preventDefault();
    var form = $(this).parents('.registration_form');
    var plateNumber = form.find('[name="plate-number"]').val();
    $.getJSON(`https://uk1.ukvehicledata.co.uk/api/datapackage/VehicleData?v=2&api_nullitems=1&auth_apikey=f6c9ca91-8e1e-4d30-9e97-208ad1614f7a&user_tag=&key_VRM=${plateNumber}`, function(data) {
      var vehicleData = data.Response.DataItems;
      if (Object.keys(vehicleData).length > 0 && vehicleData.UkvdEnhancedData.ElectricVehicleData != null) {
        localStorage.setItem('vehicleData', JSON.stringify(vehicleData));
        var brand = vehicleData.VehicleRegistration.Make;
        var model = vehicleData.VehicleRegistration.Model;
        var year = vehicleData.VehicleRegistration.YearOfManufacture;
        const chargePortDetailsList = vehicleData.UkvdEnhancedData.ElectricVehicleData.ChargePortDetailsList;
        const filteredList = chargePortDetailsList.filter(port => port.PortType.includes("Type"));
        var type = filteredList[0].PortType;
        var url = `/search?q=${brand.toLowerCase()}&type=product&plate-number=${plateNumber}`;
        window.location.href = url;
      } else {
        var url = `/search?q=&type=product&plate-number=${plateNumber}`;
        window.location.href = url;
      }
    });
  });

  if (window.location.search.indexOf('plate-number') > -1) {
    // var vehicleData = JSON.parse(localStorage.getItem('vehicleData'));
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var plateNumber = urlParams.get('plate-number');
    $.getJSON(`https://uk1.ukvehicledata.co.uk/api/datapackage/VehicleData?v=2&api_nullitems=1&auth_apikey=f6c9ca91-8e1e-4d30-9e97-208ad1614f7a&user_tag=&key_VRM=${plateNumber}`, function(data) {
      var vehicleData = data.Response.DataItems;
      console.log(vehicleData, 'vehicleData');
      if (Object.keys(vehicleData).length > 0 && vehicleData.UkvdEnhancedData.ElectricVehicleData != null) {        
        var brand = vehicleData.VehicleRegistration.Make;
        var model = vehicleData.VehicleRegistration.Model;
        var year = vehicleData.VehicleRegistration.YearOfManufacture;
        var year = vehicleData.VehicleRegistration.YearOfManufacture;
        const chargePortDetailsList = vehicleData.UkvdEnhancedData.ElectricVehicleData.ChargePortDetailsList;
        const filteredList = chargePortDetailsList.filter(port => port.PortType.includes("Type"));
        const chargeTimes = filteredList[0].ChargeTimes.AverageChargeTimes10To80Percent;
        const validChargeTimes = chargeTimes.filter((item, index) => item.TimeInMinutes !== null && index < 4);
        const maxChargePortKw = validChargeTimes.length > 0 ? Math.max(...validChargeTimes.map(item => item.ChargePortKw)) : null;
        console.log(maxChargePortKw, 'maxChargePortKw');
        var type = filteredList[0].PortType;
        if ($('[data-search-details]').length) {
          var parent = $('[data-search-details]');
          parent.show();
          var plateNumberElement = parent.find('[data-plate-number]');
          var imageElement = parent.find('[data-image]');
          var brandElement = parent.find('[data-brand]');
          var modelElement = parent.find('[data-model]');
          var yearElement = parent.find('[data-year]');
          var maxChargeElement = parent.find('[data-max-charge]');
          var typeElement = parent.find('[data-type]');
          var detailsElement = parent.find('[data-details]');
          plateNumberElement.html(`<p>${plateNumber}</p>`);
          imageElement.html(`<img src="https://cdn.vdicheck.com/badges/${brand}.png" alt="${brand}" />`);
          brandElement.html(`${brand}`);
          modelElement.html(`${model}`);
          yearElement.html(`${year}`);
          maxChargeElement.html(`${maxChargePortKw == '2.3' ? `13amp` : maxChargePortKw == '7.5' || maxChargePortKw == '7' ? `32amp` : maxChargePortKw == '11' ? `16amp (3 phase)` : maxChargePortKw == '22' ? `32amp (3 phase)` : `` }`);
          typeElement.html(`${type}`);
          detailsElement.html(`
            <h6>${type} Cables</h6>
            <div class="cables_table">
              <table>
                <thead>
                  <tr>
                    <th><p>Power</p></th>
                    <th><p>Charge Speed</p></th>
                    <th><p>Charge Time</p></th>
                  </tr>
                </thead>
                <tbody>
                  ${filteredList.length ?
                    filteredList[0].ChargeTimes.AverageChargeTimes10To80Percent.map((data, index) => `
                      ${data.TimeInMinutes !== null && index < 4 ? `<tr>
                        <td><p>${data.ChargePortKw}kW</p></td>
                        <td><p>${data.ChargePortKw == '2.3' ? `13amp` : data.ChargePortKw == '7.5' || data.ChargePortKw == '7' ? `32amp` : data.ChargePortKw == '11' ? `16amp (3 phase)` : data.ChargePortKw == '22' ? `32amp (3 phase)` : `` }</p></td>
                        <td><p>${data.TimeInMinutes !== null ? (Math.floor(data.TimeInMinutes / 60) > 1 ? Math.floor(data.TimeInMinutes / 60) + ' Hours' : Math.floor(data.TimeInMinutes / 60) + ' Hour') : 'N/A'}</p></td>
                      </tr>` : ``}
                    `).join('') : ''
                  }
                </tbody>
              </table>
            </div>
          `)
        }
      }
    });
  }

  $('body').on('click', '[data-check-compatibility]', function(e) {
    e.preventDefault();
    var form = $(this).parents('[data-compatibility]');
    var plateNumber = form.find('[data-compatibility-number]').val();
    var tag = form.find('[data-compatibility-number]').attr('data-tag');
    $('[data-null-error]').addClass('hidden');
    if (plateNumber == '') {
      $('[data-null-error]').removeClass('hidden');
      return false;
    }
    $.getJSON(`https://uk1.ukvehicledata.co.uk/api/datapackage/VehicleData?v=2&api_nullitems=1&auth_apikey=f6c9ca91-8e1e-4d30-9e97-208ad1614f7a&user_tag=&key_VRM=${plateNumber}`, function(data) {
      var vehicleData = data.Response.DataItems;
      if (Object.keys(vehicleData).length > 0 && vehicleData.UkvdEnhancedData.ElectricVehicleData != null) {
        const chargePortDetailsList = vehicleData.UkvdEnhancedData.ElectricVehicleData.ChargePortDetailsList;
        const filteredList = chargePortDetailsList.filter(port => port.PortType.includes("Type"));
        var type = filteredList[0].PortType;
        if (type.indexOf(tag) > -1) {
          var plateNumberElement = form.find('[data-registration]');
          var manufacturerElement = form.find('[data-manufacturer]');
          var modelElement = form.find('[data-model]');
          var yearElement = form.find('[data-year]');
          var brand = vehicleData.VehicleRegistration.Make;
          var model = vehicleData.VehicleRegistration.Model;
          var year = vehicleData.VehicleRegistration.YearOfManufacture;
          plateNumberElement.html(plateNumber);
          manufacturerElement.html(brand);
          modelElement.html(model);
          yearElement.html(year);
          $('[data-compatibility-details]').removeClass('hidden');
          $('[data-no-car]').removeClass('hidden');
          $('[data-success]').removeClass('hidden');
          $('[data-error]').addClass('hidden');
        } else {
          $('[data-error]').removeClass('hidden');
          $('[data-compatibility-details]').addClass('hidden');
          $('[data-no-car]').addClass('hidden');
          $('[data-success]').addClass('hidden');
        }
      } else {
        $('[data-error]').removeClass('hidden');
        $('[data-compatibility-details]').addClass('hidden');
        $('[data-no-car]').addClass('hidden');
        $('[data-success]').addClass('hidden');
      }
    });
  });

  $('body').on('click', '[data-no-car] a', function(e) {
    e.preventDefault();
    var form = $(this).parents('[data-compatibility]');
    form.find('[data-compatibility-number]').val('');
    $('[data-error]').addClass('hidden');
    $('[data-compatibility-details]').addClass('hidden');
    $('[data-no-car]').addClass('hidden');
    $('[data-success]').addClass('hidden');
  });
  $('body').on('click', '.text-row__buttons a.btn.btn_round.button--black, .text-row__buttons a.btn.btn_round.button--white', function(e) {
    e.preventDefault();
     var target = $('.hero_sec');
    topExtra = screen.width > 767 ? 0 : $('.hero_wpr').outerHeight();
    $('html, body').animate({
      scrollTop: target.offset().top + topExtra
    }, 1500);
  })

  // var $buttonContainer = $('.pdp-ctc-buttons');
  // var $button = $('.cart-drawer .add-to-cart-button');
  // var buttonOffset = $button.offset().top + $button.outerHeight();
  
  // $('.custom-drawer-body').on('scroll', function() {
  //     stickyBtn()
  // });

  // function stickyBtn() {
  //   var scrollTop = $('.custom-drawer-body').scrollTop() + $('.custom-drawer-body').height();
  //   if (scrollTop < buttonOffset) {
  //       $buttonContainer.addClass('sticky');
  //   } else {
  //       $buttonContainer.removeClass('sticky');
  //   }
  // }
  // stickyBtn()
});
